/**
 * The app uses an internal scroll container (the <main> wrapper in AppShell)
 * rather than body scroll, so the bottom nav can be a flex child instead of
 * `position: fixed` (which drifts on iOS PWAs). Because of that, `window.scrollTo`
 * no longer scrolls the content — use these helpers instead.
 */

let scrollEl: HTMLElement | null = null;

/** Registered by AppShell with the scrolling container element. */
export function setAppScrollEl(el: HTMLElement | null) {
  scrollEl = el;
}

/** Scroll the app's main content area back to the top. */
export function scrollAppToTop(behavior: ScrollBehavior = 'auto') {
  const target = scrollEl ?? document.scrollingElement ?? document.documentElement;
  target?.scrollTo({ top: 0, behavior });
}
